interface DividerProps {
  customClass?: string;
  [key: string]: unknown;
}

const Divider = ({ customClass = '' }: DividerProps) => (
  <hr
    className={`w-full my-12 border-0 border-b-2 border-solid border-b-gray ${customClass}`}
  />
);

export default Divider;
